import {humanizeString} from '@veasel/core/tools';

const humanize = (value) => humanizeString(value);

export default humanize;
